import { Icon } from '@sapphire-react/core';
import { Document } from '@sapphire/icons/react';
import { debounce } from 'lodash';
import { ReactNode, useCallback, useState } from 'react';
import type { Control, RegisterOptions } from 'react-hook-form';
import { useSapphireMedia } from '../../hooks/useSapphireMedia';
import { AmountInputField } from '../AmountInputField';

type Props = {
  label: string;
  name: string;
  control: Control<any>;
  rules:
    | Omit<
        RegisterOptions,
        'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
      >
    | undefined;
  fieldFormValue?: string;
  contextualHelp?: ReactNode;
};

export function MonthlyPayment({
  label,
  name,
  control,
  rules,
  fieldFormValue,
  contextualHelp,
}: Props) {
  const [note, setNote] = useState<string>();
  const [isFieldDirty, setIsFieldDirty] = useState<boolean>();
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const inputSize = isExtraSmall || isSmall ? 'md' : 'lg';

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setDebouncedNote = useCallback(
    debounce(
      (value: string) => {
        setNote(getNote(value));
        !isFieldDirty && setIsFieldDirty(true);
      },
      isFieldDirty ? 0 : 4000,
    ),
    [isFieldDirty],
  );

  const getNote = (expenses?: string) => {
    if (expenses && (parseInt(expenses) > 99999 || parseInt(expenses) < 7000)) {
      return 'Är du säker på att detta är din månatliga avgift eller driftskostnad?';
    }

    return undefined;
  };

  return (
    <AmountInputField
      control={control}
      name={name}
      label={label}
      rules={rules}
      width={'100%'}
      postfix={'kr'}
      min={0}
      max={999_999}
      onChange={(value) => value && setDebouncedNote(value)}
      onBlur={() => setDebouncedNote('')}
      note={note}
      contextualHelp={contextualHelp}
      prefix={
        <Icon size={inputSize}>
          <Document />
        </Icon>
      }
      onFocus={() => {
        setNote(getNote(fieldFormValue));
      }}
    />
  );
}
